import { Serializable } from './Serializable';

export class HeatmapValueDTO extends Serializable {
    departmentID: string;
    keyDriverID: string;
    score: number;

    constructor() {
        super();
    }

}
